export const roles = {
  supper_admin: 'SUPPER_ADMIN',
  admin: 'ADMIN',
  employer: 'EMPLOYER',
  employee: 'EMPLOYEE',
  agency: 'AGENCY',
  user: 'USER',
};

export const hidenPermissions = [
  'NEW_STARTERS',
  'KID',
  'ANALYTICS',
  'AGENCIES',
  'ASSIGNMENTS',
  'PROSPECTS',
];
